import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { ReactElement, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

interface L10nProviderProps {
  children: ReactNode,
}

export function L10nProvider({ children }: L10nProviderProps): ReactElement {
  const { i18n } = useTranslation()
  return (
    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={i18n.language}>
      {children}
    </LocalizationProvider>
  )
}
